import PropTypes from 'prop-types';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import { STOCK_TYPE } from 'Component/Product/Stock.config';
import { PRODUCT_ALERT_IN_STOCK } from 'Component/ProductAlerts/ProductAlerts.config';
import {
    ProductAlerts as SourceProductAlerts
} from 'SourceComponent/ProductAlerts/ProductAlerts.component';
import history from 'Util/History';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import './ProductAlerts.override.style';

/** @namespace PeggysagePwa/Component/ProductAlerts/Component */
export class ProductAlertsComponent extends SourceProductAlerts {
    static propTypes = {
        ...SourceProductAlerts.propTypes,
        isSignedIn: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
        hasInStockAlertSubscribed: PropTypes.bool.isRequired,
        onError: PropTypes.func.isRequired,
        onSuccess: PropTypes.func.isRequired
    };

    /**
     * Override
     * @returns {JSX.Element|null}
     */
    renderInStockSubscribeButton() {
        const {
            handlePriceDropSubscribeAlertInStock,
            isInStockAlertEnabled,
            stockStatus
        } = this.props;

        if (!isInStockAlertEnabled) {
            return null;
        }

        if (stockStatus === STOCK_TYPE.IN_STOCK || !stockStatus) {
            return null;
        }

        return (
            <button
              block="ProductAlerts"
              elem="InStockLink"
              onClick={ handlePriceDropSubscribeAlertInStock }
            >
                { __("M'inscrire à l'alerte") }
            </button>
        );
    }

    renderInStockSubscribeMessage() {
        return (
            <div
              block="ProductAlerts"
              elem="InStockMessage"
            >
                <p>
                    { __('Votre demande a bien été prise en compte.') }
                </p>
                <p>
                    { __('Nous vous enverrons un email dès que le produit sera de nouveau disponible.') }
                </p>
            </div>
        );
    }

    renderInStockSubscribeForm() {
        const { onError, onSuccess } = this.props;
        const { location: { state: { email = '' } = {} } } = history;

        return (
            <Form
              key="subscribe-alert"
              onSubmit={ onSuccess }
              onError={ onError }
              mix={ { block: 'ProductAlerts', elem: 'SubscribeForm' } }
            >
                <Field
                  type={ FIELD_TYPE.email }
                  label=""
                  attr={ {
                      id: 'email',
                      name: 'email',
                      defaultValue: email,
                      placeholder: __('My Email'),
                      autoComplete: 'email'
                  } }
                  validateOn={ ['onChange'] }
                  validationRule={ {
                      isRequired: true,
                      inputType: VALIDATION_INPUT_TYPE.email
                  } }
                  addRequiredTag
                />
                <input type="hidden" name="type" id="type" value={ PRODUCT_ALERT_IN_STOCK } />
                <button
                  block="Button"
                  type="submit"
                  mix={ { block: 'ProductAlerts', elem: 'SubscribeButton' } }
                >
                    { __('Validate') }
                </button>
            </Form>
        );
    }

    renderInStockSubscribeContent() {
        const {
            isSignedIn,
            isLoading,
            hasInStockAlertSubscribed
        } = this.props;

        if (isLoading) {
            return __('Loading...');
        }

        if (hasInStockAlertSubscribed) {
            return this.renderInStockSubscribeMessage();
        }

        if (isSignedIn) {
            return this.renderInStockSubscribeButton();
        }

        return this.renderInStockSubscribeForm();
    }

    renderInStockSubscribeWrapper() {
        const {
            isInStockAlertEnabled,
            stockStatus
        } = this.props;

        if (!isInStockAlertEnabled) {
            return null;
        }

        if (stockStatus === STOCK_TYPE.IN_STOCK || !stockStatus) {
            return null;
        }

        return (
            <div
              block="ProductAlerts"
              elem="InStock"
            >
                <div
                  block="ProductAlerts"
                  elem="InStockTitle"
                >
                    { __("M'avertir du retour en stock") }
                </div>
                <div
                  block="ProductAlerts"
                  elem="InStockContent"
                >
                    { this.renderInStockSubscribeContent() }
                </div>
            </div>
        );
    }

    /**
     * Override: display
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div
              block="ProductAlerts"
              elem="Wrapper"
            >
                { this.renderPriceDropSubscribeButton() }
                { this.renderInStockSubscribeWrapper() }
            </div>
        );
    }
}

export default ProductAlertsComponent;
